export const mergePermissionsParser = permissions => {
  const mergedPermissions = Object.values(permissions).reduce(
    (p, c) => ({
      ...p,
      ...c,
    }),
    [],
  );

  return Object.entries(mergedPermissions).map(permission => permission[0]);
};
